import React, { useRef } from "react";
import styles from '../../css/Part12.module.css';

function ContactUs() {
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    // Construct form data to send in the API request
    const formData = new FormData(form.current);
    const data = {
      formType: 'contact', // Add the formType here
      name: formData.get("name"),
      company: formData.get("company"),
      phone: formData.get("phone"),
      email: formData.get("email"),
      subject: formData.get("subject"),
      message: formData.get("message"),
    };

    // Make a POST request to your backend API
    try {
      const response = await fetch("https://fone_api.gakkixmasami.com/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert("Message sent successfully!");
      } else {
        throw new Error("Failed to send message");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send message.");
    }

    // Reset the form after submission
    e.target.reset();
  };

  return (
    <section className={styles.contactSection} id="section_ContactUs">
      <div>
        <h4>ARE YOU READY</h4>
        <h2>Contact Us</h2>
        <h5>If you need to contact us, please email us at Support@forestone.com.my</h5>
        <div className={styles.contactContainer}>
          <div className={styles.contactLeft}>
            <h3>Get In Touch</h3>
            <h6>we're happy to help!</h6>
            <div className={styles.contactInfo}>
              <div className={styles.infoItem}>
                <img src="images/icons/location vector.png" alt="Location" className={styles.vectorsize} />
                <p>
                  <strong>Head Office</strong><br />
                  No. 8C, Jalan Teknologi 3/4, Taman Sains Selangor 1,<br />
                  Kota Damansara, 47810 Petaling Jaya, Selangor, Malaysia
                </p>
              </div>

              <div className={styles.infoItem}>
                <img src="images/icons/email vector.png" alt="email" className={styles.vectorsize} /> 
                <p><strong>Email Us</strong><br />support@forestone.com.my</p>
              </div>

              <div className={styles.infoItem}>
                <img src="images/icons/phone vector.png" alt="phone" className={styles.vectorsize} /> 
                <p><strong>Call Us</strong><br />Phone: 1700 81 9183</p>
              </div>
            </div>
            <div>
              <p>______________________________________</p>
            </div>
            <div className={styles.socialMedia}>
              <p><strong>Follow Our Social Media</strong></p>
              <a href="https://www.facebook.com/FoneAppMY" target="_blank" rel="noopener noreferrer">
                <img src="images/icons/facebook vector.png" alt="Facebook" className={styles.vectorsize} />
              </a>
              <a href="https://www.instagram.com/foneappmy/" target="_blank" rel="noopener noreferrer">
                <img src="images/icons/instagram vector.png" alt="Instagram" className={styles.vectorsize} />
              </a>
            </div>
          </div>

          <div className={styles.contactRight}>
            <h3>Send us a message</h3>
            <form ref={form} onSubmit={sendEmail}>
              <div className={styles.inputGroup}>
                <input type="text" name="name" placeholder="Name" required />
                <input type="text" name="company" placeholder="Company" />
              </div>
              <div className={styles.inputGroup}>
                <input type="text" name="phone" placeholder="Phone" required />
                <input type="text" name="email" placeholder="Email" required />
              </div>
              <div className={styles.inputGroup}>
                <input type="text" name="subject" placeholder="Subject" />
              </div>
              <div className={styles.inputGroup}>
                <textarea name="message" placeholder="Message" rows="4" required></textarea>
              </div>
              <div className={styles.button}>
                <button type="submit" className={styles.submitButton}>SEND</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
